import React from "react";
import { Link } from "react-router-dom";

export const bags = [
  {
    name: "Plastic T-Shirt Bags",
    images: ["/images/TS/bag.png"],
    description: `1/6 barrel plastic carry out bags. Made with high quality virgin plastic. Two versions available: standard thickeness and heavy duty.`,
    features: ["Recyclable", "Reusable"],
    specs: [
      {
        label: "SKU",
        values: ["12.5mic", "18mic"],
      },
      {
        label: "Name",
        values: ["1/6 T-Shirt Bag 12.5 microns", "1/6 T-Shirt Bag 18 microns"],
      },
      {
        label: "Product Dimensions (in)",
        values: ["11.5 × 6.5 × 22", "11.5 × 6.5 × 22"],
      },
      {
        label: "Case Pack",
        values: ["1000pc", "1000pc"],
      },
    ],
    link: "/bags/tshirt",
  },
  {
    name: "Brown Paper Bags",
    images: ["/images/Paper/duro.png"],
    description: `Extra heavy duty brown paper bags. Perfect for smaller delicacies such as deli items and fresh produce.`,
    features: [
      "Recyclable",
      "BPI Certified",
      "No PFAS Added",
      "Made in America",
    ],
    specs: [
      {
        label: "SKU",
        values: ["20SH", "25SH"],
      },
      {
        label: "Name",
        values: [
          "20lb 57# Shorty Brown Paper Bag",
          "25lb 57# Shorty Brown Paper Bag",
        ],
      },
      {
        label: "Product Dimensions (in)",
        values: ["8.25 × 5.3125 × 13.375", "8.25 × 6.125 × 15.875"],
      },
      {
        label: "Case Pack",
        values: ["400pc", "400pc"],
      },
    ],
    link: "/bags/paperbag",
  },
  {
    name: "Black Trash Bags",
    images: ["/images/Trash/trash.png"],
    description: `Extra heavy duty black trash bags. Find the perfect size and strength bag for your needs.`,
    features: ["Recycled", "Heavy Duty", "Made in America"],
    specs: [
      {
        label: "SKU",
        values: [
          "39Gal1.5",
          "39Gal2",
          "46Gal1.5",
          "58Gal1.35",
          "58Gal1.75",
          "58Gal2.6",
        ],
      },
      {
        label: "Name",
        values: [
          "39 Gallon 1.5 mil Extra Heavy Duty Trash Bags",
          "39 Gallon 2 mil Super Heavy Duty Trash Bags",
          "46 Gallon 1.5 mil Extra Heavy Duty Trash Bags",
          "58 Gallon 1.35 mil Heavy Duty Trash Bags",
          "58 Gallon 1.75 mil Extra Heavy Duty Trash Bags",
          "58 Gallon 2.6 mil Super Heavy Duty Trash Bags",
        ],
      },
      {
        label: "Product Dimensions (in)",
        values: [
          "34 × 39",
          "34 × 39",
          "38 × 46",
          "38 × 56",
          "38 × 56",
          "38 × 56",
        ],
      },
      {
        label: "Case Pack",
        values: ["100pc", "100pc", "100pc", "100pc", "75pc", "50pc"],
      },
    ],
    link: "/bags/trashbag",
  },
];

const Bags = () => {
  return (
    <div className="bg-containx-navy min-h-screen p-6">
      <h1 className="text-4xl font-bold text-center mb-6 text-white">
        Our Bags
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {bags.map((bag, index) => (
          <div
            key={index}
            className="bg-containx-charcoal/30 text-white rounded-lg shadow-md overflow-hidden hover:bg-containx-beige/50 hover:text-containx-navy transition-shadow duration-200"
          >
            <Link to={bag.link}>
              <img
                src={bag.images[0]}
                alt={bag.name}
                className="w-full h-48 object-contain"
              />
              <div className="p-4">
                <h2 className="text-xl font-semibold">{bag.name}</h2>
                <p className="text-gray-700">{bag.description}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bags;
